var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAppInteractionFilled = function SvgAppInteractionFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.624 3.563a1.875 1.875 0 1 0-3.248-1.875L5.803 14.805l4.32.017 6.5-11.26ZM7.53 19.31l-4.32-.016-.335.58a1.875 1.875 0 1 0 3.248 1.874l1.407-2.438Zm6.793-4.095L2.257 15.17a1.875 1.875 0 0 0-.014 3.75l14.25.056-2.17-3.759Zm7.378 3.78-2.17-3.76 2.225.01a1.875 1.875 0 1 1-.015 3.75h-.04ZM11.374 1.687l.784 1.359-2.165 3.75-1.867-3.234a1.875 1.875 0 1 1 3.248-1.875Zm1.217 9.609 2.166-3.75 7.117 12.327a1.875 1.875 0 1 1-3.248 1.875l-6.035-10.452Z",
    clipRule: "evenodd"
  })));
};
export default SvgAppInteractionFilled;